<template>
	<div full-height grey-back>

        <v-toolbar flat fixed>
            <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
            <v-toolbar-title class="white--text">Business Settings</v-toolbar-title>
        </v-toolbar>

    	<div class="hasToolbar">
            
            <!-- <v-list two-line nopadding v-if="$root.CurrentBusiness">
                
                <v-list-tile avatar>

                    <v-list-tile-avatar>
                        <img :src="$root.CurrentBusiness.businessLogo" v-if="$root.CurrentBusiness.businessLogo"/>
                        <v-icon class="primary-color white--text" v-else>business</v-icon>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                        <v-list-tile-title>{{$root.CurrentBusiness.BusinessName}}</v-list-tile-title>
                        <v-list-tile-sub-title>Created On: {{$root.CurrentBusiness.CreatedOn | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                
                </v-list-tile>

            </v-list> -->

            <v-list nopadding two-line>
              
                <v-list-tile v-ripple @click="fn_editBusiness">

                    <v-list-tile-action>
                        <v-icon class="primary-color">edit</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Business Profile</v-list-tile-title>
                        <v-list-tile-sub-title>Edit/Update business details</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile to="/settings/openingdate">
                      <v-list-tile-action>
                          <v-icon class="primary-color">date_range</v-icon>
                      </v-list-tile-action>

                      <v-list-tile-content>
                          <v-list-tile-title>Opening Date</v-list-tile-title>
                          <v-list-tile-sub-title>Set/Update opening date</v-list-tile-sub-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                          <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                      </v-list-tile-action>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile @click="fn_itemSettings">
                      <v-list-tile-action>
                          <!-- <v-icon class="primary-color">settings</v-icon> -->
                          <img src="../../../assets/icon_category_blue.svg" alt="icon_category"/>
                      </v-list-tile-action>

                      <v-list-tile-content>
                          <v-list-tile-title>Item Settings</v-list-tile-title>
                          <v-list-tile-sub-title>Update your item settings</v-list-tile-sub-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                          <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                      </v-list-tile-action>
                </v-list-tile>

                <v-divider></v-divider>

                <template v-if="$root.appVersion >= 109">
                    <v-list-tile to="/settings/business/transactionnew">
                        <v-list-tile-action>
                            <v-icon class="primary-color">settings</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                            <v-list-tile-title>Transaction Settings</v-list-tile-title>
                            <v-list-tile-sub-title>Update your transaction settings</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                        </v-list-tile-action>
                    </v-list-tile>
                    <v-divider></v-divider>
                </template>

                <template v-if="$root.appVersion >= 234">
                    <v-list-tile to="/fields/items">
                        <v-list-tile-action>
                            <v-icon class="primary-color">text_fields</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                            <v-list-tile-title>Transaction Fields</v-list-tile-title>
                            <v-list-tile-sub-title>Update transaction custom fields</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                        </v-list-tile-action>
                    </v-list-tile>
                    <v-divider></v-divider>
                </template>

                <template>
                    <v-list-tile @click="fn_thermalPrintSettings">
                        <v-list-tile-action>
                            <v-icon class="primary-color">print</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                            <v-list-tile-title>Thermal Print Settings</v-list-tile-title>
                            <v-list-tile-sub-title>Update thermal print settings</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider></v-divider>

                    <template v-if="$root.appVersion >= 325">
                        <v-list-tile @click="fn_labelPrintSettings">
                            <v-list-tile-action>
                                <v-icon class="primary-color">label</v-icon>
                            </v-list-tile-action>

                            <v-list-tile-content>
                                <v-list-tile-title>{{ $t('settings.labelPrint.title') }}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ $t('settings.labelPrint.updateDesc') }}</v-list-tile-sub-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-divider></v-divider>
                    </template>

                </template>
                

                <v-list-tile v-ripple @click="fn_upiPayment">

                    <v-list-tile-action>
                        <v-icon class="primary-color">account_balance</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>UPI Payment</v-list-tile-title>
                        <v-list-tile-sub-title>Add/Share UPI payment link (PayTM, PhonePe, Google Pay)</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile v-ripple @click="fn_languageSettings">

                    <v-list-tile-action>
                        <v-icon class="primary-color">language</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Language Settings</v-list-tile-title>
                        <v-list-tile-sub-title>Update language preferences</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                
                </v-list-tile>
                
                <v-divider></v-divider>

                <v-list-tile v-ripple @click="fn_addLogo" v-if="$root.CurrentBusiness">

                    <v-list-tile-action>
                        <v-icon class="primary-color">add_a_photo</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Business Logo</v-list-tile-title>
                        <v-list-tile-sub-title>{{$root.CurrentBusiness.businessLogo ? 'Change your business logo' : 'Add your business logo'}}</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile v-ripple @click="fn_goToPrintFields">

                    <v-list-tile-action>
                        <v-icon class="primary-color">text_fields</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Print Fields</v-list-tile-title>
                        <v-list-tile-sub-title>Update printing content of bill/invoice</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile v-ripple @click="fn_changeUserType">

                    <v-list-tile-action>
                        <v-icon color="primary">sync</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Change User Type</v-list-tile-title>
                        <v-list-tile-sub-title>Update user type</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon color="primary">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile v-ripple @click="fn_changeNumber">

                    <v-list-tile-action>
                        <v-icon class="primary-color">smartphone</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Change Number</v-list-tile-title>
                        <v-list-tile-sub-title>Update admin/login mobile number</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile v-ripple @click="fn_dataBackup">

                    <v-list-tile-action>
                        <v-icon class="primary-color">backup</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Data Backup</v-list-tile-title>
                        <v-list-tile-sub-title>Backup data, change backup drive</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile @click="fn_openSecurityLock(3)" v-ripple>
                    <v-list-tile-action>
                        <v-icon class="redcolor">delete</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Clear Data</v-list-tile-title>
                        <v-list-tile-sub-title>Clear transactions and data</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon class="redcolor">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile v-ripple @click="fn_openSecurityLock(2)">

                    <v-list-tile-action>
                        <v-icon class="redcolor">remove_circle_outline</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Delete</v-list-tile-title>
                        <v-list-tile-sub-title>Delete current business</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon class="redcolor">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                
                </v-list-tile>

            </v-list>

            <!-- <input type="file" id="logo" accept="image/*" style="visibility:hidden;"> -->

        </div>

        <dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :actionMethod="actionMethod" okBtnText="Yes" cancelBtnText="No" icon="error_outline"></dialog-confirmation>

        <!-- <dialog-confirmation ref="ref_dialogConfirmation" header="confirmationHeader" confirmationMessage="<div class='pl-3 pr-3 pt-2 pb-2 mb-2' style='background:#fff3cd;color:#856404;border-radius:5px'><p class='mb-1 font16 font-medium'>Warning: You could lose your data, if you didn’t configure auto backup and changed device.</p></div><p class='mb-1 font16'>Are you sure you want to skip auto data backup?</p>" okBtnText="Setup Now" cancelBtnText="Yes" :actionMethod="fn_gotoSetupDrive" :cancelMethod="fn_closeDialogConfirmation"></dialog-confirmation> -->

        <dialog-business-name ref="ref_dialogBusinessName" header="Delete Business?"></dialog-business-name>
       
	</div>
</template>

<script>
const dialogjs =  require('../../masters/forms/dialog').dialogjs;
import dialogConfirmation from '../../dialogs/dialog_confirmation'
import dialogBusinessName from '../../dialogs/dialog_business_name'

  export default{

    data(){
        return{
            base64Image:null,
            formId:null,
            dialogStorageId:null,
            confirmationHeader:null,
            confirmationMessage:null,
            actionMethod:null
        }
    },
    components:{
        'dialog-confirmation': dialogConfirmation,
        'dialog-business-name': dialogBusinessName
    },
    methods:{

        fn_changeUserType: function(){
            this.$router.push({path:"/registration/business/usertype"});
        },

        fn_upiPayment: function(){
            if(this.$root.CurrentBusiness.UpiID){
                this.$router.push({"path":"/settings/payment/upi/display"});    
            }
            else{
                this.$router.push({"path":"/settings/payment/upi/new"});    
            }
        },

        fn_addLogo: function(){
            this.$router.push("/settings/logo/upload");
        },

        fn_goBack: function(){
            this.$router.go(-1);
        },

        fn_editBusiness: function(){
            this.$router.push({path:'/registration/business/'+this.$root.CurrentBusiness.BusinessID+'/edit'});
        },

        fn_clearData: function(){

            if(!this.$root.CurrentBusiness.DataDrive){
                this.showToast("Please first set up backup drive");
                this.$router.push({path:"/registration/business/setupdrive"});
            }
            else{
                this.$router.push({path:"/settings/cleardata"});
            }

        },

        fn_checkIsBackupRunning: function(){

            if(!this.$root.CurrentBusiness.DataDrive){
                this.showToast("Please first set up backup drive");
                this.$router.push({path:"/registration/business/setupdrive"});
                return;
            }

            if(!navigator.onLine){
                this.showToast('Internet not available');
                return;
            }

            let isBackupRunning = JSON.parse(AndroidRoutingTest.isBackupRunning());
            if(isBackupRunning){
                this.showToast("Data backup under processing. Try again after some time");
            }
            else{
                this.confirmationHeader = "Delete Business?"
                this.actionMethod = this.fn_confirmDeactivate;
                this.confirmationMessage = "<div class='pl-3 pr-3 pt-2 pb-2 mb-2' style='background:#f8d7da;color:#721c24;margin:0px -16px;'><p class='mb-1 font16 font-medium'><span font18>Warning!</span> <br> This action can't be undone!<br>You would lose your data, if you delete your business.</p></div><p class='mb-1 font16'>Are you sure you want to delete this business?</p><p></p>";
                // this.fn_openSecurityLock(2);
                this.fn_openDialogMatchBusiness();
            }
        },

        fn_openSecurityLock: function(type){
            let self = this;
            this.getData('VerifyScreenLock', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        // self.fn_openDialogMatchBusiness();
                        let status = JSON.parse(response);
                        if(status){
                            if(type==1){
                                // self.fn_openDialogConfirmation();
                                self.fn_confirmChangeNumber();
                            }
                            if(type==2){
                                // self.fn_openDialogMatchBusiness();
                                self.fn_checkIsBackupRunning();
                            }
                            else if(type==3){
                                self.fn_clearData();
                            }
                        }
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_openDialogMatchBusiness: function(){
            this.fn_openDialogWeb('web', 'MatchBusinessNameDialog', 'ref_dialogBusinessName');
        },

        fn_openDialogConfirmation: function(closeDialog){
            closeDialog ? this.fn_closeDialog() : '';
            let self = this;
            setTimeout(function(){
                self.fn_openDialogWeb('web', 'DiscardDialog', 'ref_dialogConfirmation');
            },closeDialog ? 300 : 0);
        },

        fn_openDialogWeb: function (platform, name, ref) {

            let scroll_y = window.scrollY;
            this.fn_fixBackgroundScroll();

            var dialogObj = {};
            dialogObj.tagId = this.guidWeb();
            dialogObj.formId = this.formId;
            dialogObj.name = name;
            dialogObj.ref = ref;
            dialogObj.data = null;
            dialogObj.platform = platform;

            dialogObj.scrollPosition = {};
            dialogObj.scrollPosition.x = 0;
            dialogObj.scrollPosition.y = scroll_y;

            dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

            let self = this;

            this.$refs[ref].openDialogWeb();
        },

        fn_closeDialog: function(){
            dialogjs.fn_checkAndCloseOpenDialogs(this);
        },

        fn_changeNumber: function(){

            if(!navigator.onLine){
                this.showToast('Internet not available');
                return;
            }

            // this.confirmationHeader = "Change Number?"
            // this.confirmationMessage = null;
            // this.actionMethod = this.fn_confirmChangeNumber;
            
            this.fn_openSecurityLock(1);
        },

        fn_confirmChangeNumber: function(){
            this.fn_closeDialog();
            let self = this;
            setTimeout(function(){
                self.$router.push({path:"/registration/business/change_phone_number"})
            })
            // this.showLoading('Please wait...');
            // this.$root.fn_getAuthToken(function(token){
            //     self.$root.fn_getPhoneNumber(token, function(mobileNumber){
            //         self.hideLoading();
            //         self.fn_getOtpForChangeNumber(mobileNumber);
            //     });
            // });
        },

        fn_dataBackup: function(){
            // if(!navigator.onLine){
            //     this.showToast('Internet not available');
            //     return;
            // }

            if(this.$root.CurrentBusiness && this.$root.CurrentBusiness.DataDrive){
                this.$router.push({path:"/settings/backup"});
            }
            else{
                this.$router.push({path:"/registration/business/setupdrive"});
            }

        },

        fn_newBusiness: function(){
            this.$router.push({path:"/registration/business/new"});
        },

        fn_goToPrintFields: function(){
            this.$router.push({path:"/printfield/items", query:{new:false}});
        },

        fn_confirmDeactivate: function(){
            this.fn_closeDialog();
            // let self = this;
            // this.showLoading('Please wait...');
            // this.$root.fn_getAuthToken(function(token){
            //     self.$root.fn_getPhoneNumber(token, function(mobileNumber){
            //         self.hideLoading();
            //         self.fn_getOtpForDeactivate(mobileNumber);
            //     });
            // });
            this.fn_backupAllBusinessData();
        },

        // fn_getOtpForDeactivate: function(mobileNumber){
        //     this.$router.push({
        //         name:'otpVerification', 
        //         query:{mobile_number:mobileNumber, requestType:3},
        //         params: {
        //             verifyCallback: this.fn_verifyCallbackForDeactivate
        //         }
        //     });
        // },

        // fn_verifyCallbackForDeactivate: function(requestId, otp){
        //     this.fn_goBack();
        //     this.hideLoading();
        //     this.fn_backupAllBusinessData(requestId, otp);
        // },

        // fn_getOtpForChangeNumber: function(mobileNumber){
        //     this.$router.push({
        //         name:'otpVerification', 
        //         query:{mobile_number:mobileNumber, requestType:4},
        //         params: {
        //             verifyCallback: this.fn_verifyCallbackForChangeNumber
        //         }
        //     });
        // },

        fn_verifyCallbackForChangeNumber: function(token){
            this.hideLoading();
            this.$router.replace({name:"changePhoneNumber", params: { 'token': token }});
            // this.$router.replace({path:"/registration/business/change_phone_number", query:{'token': token}});
        },

        // fn_backupAllBusinessData: function(requestId, otp){
        //     let self = this;
        //     this.showLoading('Backing up data...');
        //     this.getData('BackupAllData', this.$root.CurrentBusiness.BusinessID, 
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //                 self.showToast('Data backup complete');
        //                 // self.hideLoading();
        //                 self.$root.fn_getAuthToken(function(token){
        //                     self.hideLoading();
        //                     self.fn_deactivateBusiness(token, requestId, otp);
        //                 })
        //             },
        //             onError: function(error){
        //                 console.log(error);
        //                 self.hideLoading();
        //                 self.showToast('Data backup failed');
        //             }
        //         }
        //     );
        // },

        // fn_backupAllBusinessData: function(requestId, otp){
        fn_backupAllBusinessData: function(){
            let self = this;

            let filterObject = {}
            filterObject.complexOperation = true;

            this.showLoading('Backing up your data before deactivating business...');
            this.getFilterData('BackupAllData', this.$root.CurrentBusiness.BusinessID, filterObject,
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.showToast('Data backup complete');
                        // self.hideLoading();
                        self.$root.fn_getAuthToken(function(token){
                            // self.hideLoading();
                            // self.fn_deactivateBusiness(token, requestId, otp);
                            self.fn_deactivateBusiness(token);
                        })
                    },
                    onError: function(error){
                        console.log(error);
                        self.hideLoading();
                        self.showToast('Data backup failed');
                    }
                }
            );
        },

        fn_deactivateBusiness: function(token){
            if(!navigator.onLine){
                this.showToast('Internet not available');
                return;
            }
            
            let self = this;
            let filterObject = {};
            filterObject.businessId = this.$root.CurrentBusiness.BusinessID;
            filterObject.token = token;
            filterObject.reloadApp = true;
            this.getServerData('DeactiveBusinessDirect', filterObject, 
                {
                    onSuccess: function(response){
                        self.hideLoading();
                        self.fn_resetData();
                    }, 
                    onError: function(error){
                        console.log(error);
                        self.hideLoading();
                        if(typeof JSON.parse(error) == 'object'){
                            let response = JSON.parse(error);
                            self.showToast(response.Message);
                        }
                    }, 
                }
            );
        },

        // fn_deactivateBusiness: function(token, requestId, otp){
        //     if(!navigator.onLine){
        //         this.showToast('Internet not available');
        //         return;
        //     }
            
        //     var self = this;
        //     this.showLoading('Deactivating business...');
        //     let filterObject = {};
        //     filterObject.BusinessID = this.$root.CurrentBusiness.BusinessID;
        //     filterObject.RequestID = requestId;
        //     filterObject.OTP = otp;
        //     filterObject.token = token;

        //     this.postServerData('Deactivate', filterObject, 
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //                 self.hideLoading();
        //                 self.fn_clearData();
        //             }, 
        //             onError: function(error){
        //                 console.log(error);
        //                 self.hideLoading();
        //                 if(typeof JSON.parse(error) == 'object'){
        //                     let response = JSON.parse(error);
        //                     self.showToast(response.Message);
        //                 }
        //             },
        //         }
        //     );
        // },

        fn_resetData: function(){
            localStorage.removeItem("first_invoice_added");
            localStorage.removeItem("demo_customer_item_added");
            this.showToast("Business: "+this.$root.CurrentBusiness.BusinessName +' deleted');
            this.$root.CurrentBusiness = null,
            this.$root.Businesses = { "BusinessList": null, "BusinessCount":0};
            localStorage.removeItem('bottomNavigationSet');
            // this.$router.replace({path:'/registration/business/login'});
        },
        
        fn_itemSettings: function(){
            this.$router.push({path:"/settings/business/transactionnew", query:{"item":1}});
        },

        fn_thermalPrintSettings: function(){
            this.$router.push({path:"/settings/business/thermalprintsettings"});
        },

        fn_labelPrintSettings: function(){
            this.$router.push({path:"/settings/business/labelprintsettings"});
        },

        fn_languageSettings: function(){
            this.$router.push({path:"/settings/language"});
        }

    },
    mounted: function () {
        this.formId = this.guidWeb();
        this.dialogStorageId = 'dialog_'+this.formId;
        window.js_globals.fn_onBackPress = this.fn_goBack;
    },
    beforeRouteLeave (to, from, next) {
        var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
        if(dialogData && dialogData.length){
            dialogjs.fn_checkAndCloseOpenDialogs(this);
            next(false);
        }
        else{
            next();
        }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/settings/business/business_settings.vue